<!-- =========================================================================================
  File Name: MemberEditTabInformation.vue
  Description: Member Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>

    <!-- Content Row -->
    <div class="vx-row"> 
      <div class="vx-col md:w-1/2 w-full">
        <vs-input class="w-full mt-4" label="* ID" v-model="member_data.userID" v-validate="'required'" name="userID" disabled />
        <span class="text-danger text-sm" v-show="errors.has('userID')">{{ errors.first('userID') }}</span>

        <vs-input class="w-full mt-4" label="* 비밀번호" v-model="member_data.password" type="password" v-validate="'required'" name="password" />
        <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>

        <vs-input class="w-full mt-4" label="* 이름" v-model="member_data.name" v-validate="'required'" name="name" />
        <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>

        <vs-input class="w-full mt-4" label="전화번호" v-model="member_data.telephone" name="telephone" v-validate="'max:25'"/>
        <span class="text-danger text-sm" v-show="errors.has('telephone')">{{ errors.first('telephone') }}</span>

        <vs-input class="w-full mt-4" label="핸드폰번호" v-model="member_data.mobilephone" name="mobilephone" v-validate="'max:25'"/>
        <span class="text-danger text-sm" v-show="errors.has('mobilephone')">{{ errors.first('mobilephone') }}</span>

        <vs-input class="w-full mt-4" label="이메일" v-model="member_data.eMail" type="email" name="eMail" v-validate="'email'"/>
        <span class="text-danger text-sm" v-show="errors.has('eMail')">{{ errors.first('eMail') }}</span>

      </div>

      <div class="vx-col md:w-1/2 w-full">  
        <div class="flex flex-wrap mt-4">
          <div class="w-1/2">
            <vs-input class="w-full" label="우편번호" disabled v-model="member_data.zipCode" name="zipCode" />
            <!-- <span class="text-danger text-sm" v-show="errors.has('zipCode')">{{ errors.first('zipCode') }}</span> -->
          </div>
          <div class="w-1/2">
            <vs-button class="mt-5 ml-4" @click="popupActive=true">주소 검색</vs-button>
          </div>
        </div>

        <vs-input class="w-full mt-4" label="주소" disabled v-model="member_data.zipName" name="zipName" />
        <!-- <span class="text-danger text-sm" v-show="errors.has('zipName')">{{ errors.first('zipName') }}</span> -->

        <vs-input class="w-full mt-4" label="주소세부" v-model="member_data.zipDetail" name="zipDetail" />
        <span class="text-danger text-sm" v-show="errors.has('zipDetail')">{{ errors.first('zipDetail') }}</span>

        <vs-select v-model="member_data.instituteSeq" label="* 소속학원" class="mt-4 w-full" name="item-instituteSeq" v-validate="'required'">
          <vs-select-item :key="item.instituteSeq" :value="item.instituteSeq" :text="item.instituteName" v-for="item in instituteOptions" />
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('item-instituteSeq')">{{ errors.first('item-instituteSeq') }}</span>
  
        <vs-select v-model="member_data.userType" label="* 사용자타입" class="mt-4 w-full" name="item-usertype" v-validate="'required'">
          <vs-select-item :key="item.userType" :value="item.userType" :text="item.description" v-for="item in userTypeOptions" />
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('item-usertype')">{{ errors.first('item-usertype') }}</span>
  
        <vs-select v-model="member_data.status" label="* 상태" class="mt-4 w-full" name="item-status" v-validate="'required'">
          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in statusOptions" />
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('item-status')">{{ errors.first('item-status') }}</span>

      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="confirmSaveChanges" :disabled="!validateForm">수정</vs-button>
          <!-- <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button> -->
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.go(-1)">취소</vs-button>
        </div>
      </div>
    </div>

    <!-- Daum 우편번호 서비스 -->
    <vs-popup class="holamundo" title="주소 검색" :active.sync="popupActive">
      <p>
        <vue-daum-postcode @complete="this.daumPostCode" />
      </p>
    </vs-popup>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import * as lang from 'vuejs-datepicker/src/locale'
import vSelect from 'vue-select'
import { VueDaumPostcode } from 'vue-daum-postcode'

import { fetchData, putData } from '@/api/module'

export default {
  components: {
    vSelect,
    Datepicker,
    VueDaumPostcode
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return { 
      languages: lang,
      popupActive: false,
      member_data: JSON.parse(JSON.stringify(this.data)),
      instituteOptions: [],
      userTypeOptions: [],
      statusOptions: [
        {
          value: 0,
          text: '정상'
        },
        {
          value: 1,
          text: '탈퇴'
        }
      ]
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any()
    }
  },
  methods: {
    daumPostCode (value) {
      // console.log(`result: ${JSON.stringify(value)}`)
      this.member_data.zipCode = value.zonecode
      this.member_data.zipName = value.address

      this.popupActive = false
    },
    confirmSaveChanges () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '학원 정보 수정',
        text: '저장 하시겠습니까?',
        accept: this.saveChanges,
        acceptText: '저장'
      })
    },
    async saveChanges () {
      if (!this.validateForm) return

      try {
        const { data } = await putData('member', this.member_data)
        console.log(data)
        const userID = this.member_data.userID
        this.$router.push(`/member/member-view/${userID}`)
        this.showSaveChangesSuccess()

      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    showSaveChangesSuccess () {
      this.$vs.notify({
        color: 'success',
        title: '학원 정보 수정',
        text: '저장 되었습니다.'
      })
    },
    reset_data () {
      this.member_data = JSON.parse(JSON.stringify(this.data))
    },
    async loadInstitutes () {
      try {
        const keyword = ''
        const institutes  = await fetchData('institute/search', keyword)
        // console.log(institutes.data);
        this.instituteOptions = institutes.data.list
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    async loadUserType () {
      try {
        const userTypes = await fetchData('member-type')
        this.userTypeOptions = userTypes.data.list
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    }
  },
  created () {
    this.loadInstitutes()
    this.loadUserType()
  }
}
</script>
